import React, { useEffect } from 'react';
import ProfileTable from '../../components/profileTable/ProfileTable';
import { generalStore } from '../../store';
import { useTranslation } from 'react-i18next';

const ProfileView = () => {
    const { t, i18n } = useTranslation();
    const { setPageName } = generalStore();

    useEffect(() => {
        setPageName(t('page_name_profile'));
    }, [i18n.language]);

    return (
        <div className="b-profile-view">
            <ProfileTable />
        </div>
    );
};

export default ProfileView;
